import "./loader.css";

const ShowLoader = () => {
    return (
        <div className="loader-page">
            <div className="loader"></div>
        </div>
    );
};

export default ShowLoader;
